import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/images/placeholders/placeholder-video.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/admin/sidebar/AdminSidebar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/admin/sidebar/items/login/LoginButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/cleverfeed/CleverFeedLocationSearchBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedPageWrapperHeaderClientMobileDropdown"] */ "/app/packages/components/components/header/cleverfeed/client/SchoolFeedPageWrapperHeaderClientMobileDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedPageWrapperHeaderClientSideBar"] */ "/app/packages/components/components/header/cleverfeed/client/SchoolFeedPageWrapperHeaderClientSideBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/CleverFeedHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/SchoolFeedPageWrapperHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/header/cleverfeed/styles/SubmitOrganizationButton.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/schoolfeed/SchoolFeedSearchFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebAppInstallPrompt"] */ "/app/packages/components/components/header/WebAppInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdminMenuClientWrapper"] */ "/app/packages/components/components/misc/AdminMenuClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationContainer"] */ "/app/packages/components/components/notifications/NotificationContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/leaderboard/Leaderboard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/schoolfeed/SchoolFeedFilesDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedMediaDisplay"] */ "/app/packages/components/components/schoolfeed/SchoolFeedMediaDisplay.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/SchoolFeedMonthCalendar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SchoolFeedNewsLoading","default"] */ "/app/packages/components/components/schoolfeed/SchoolFeedNewsDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/schoolfeed/SchoolFeedSplainerPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/styles/SchoolFeedDisplay.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/styles/UnclaimedPage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/ContributingOrganizationsWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsWidget"] */ "/app/packages/components/components/schoolfeed/widgets/NewsWidget.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/SchoolFeedContactCard.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/ShopWidget.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/styles/MeritChatModeratorWidget.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/styles/RightColumnWidget.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/schoolfeed/widgets/WidgetRenderer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ListCalendar"] */ "/app/packages/components/components/utilities/CleverCalendar/ListCalendar.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/ClickableLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DragAndDropProvider"] */ "/app/packages/components/components/utilities/DragAndDropProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MeritChatModeratorMenu"] */ "/app/packages/components/components/utilities/MeritChat.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/components/utilities/rollbar/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerManager"] */ "/app/packages/components/components/utilities/ServiceWorkerManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnreadNotificationsConsumer"] */ "/app/packages/components/components/utilities/UnreadNotificationsConsumer.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/AccordionItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/AlphaCollectionPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/MapFixedCollectionPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/NewsItemPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/SearchPage/SearchPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/styles/LeaderboardPage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/styles/ContentItemPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/UserDashboard/UserDashboardPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/pages/UserSettings/UserSettingsPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/stores/ClientTransitionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreContext"] */ "/app/packages/components/stores/StoreContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/styles/_variables.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleContextProvider"] */ "/app/packages/components/utils/LocaleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/schoolfeed/app/[lang]/[[...all]]/ProfileCompletionCheck.jsx");
